import React, { useEffect } from 'react';
import _get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';
import { isLoading, isNormal, useStatus, useData, combineStatuses } from 'resift';
import makeStyles from '@material-ui/core/styles/makeStyles';
import getWidgetTypes from 'fetches/homepageWidgets/getWidgetTypes';
import getWidgets from 'fetches/homepageWidgets/getWidgets';
import CircularProgress from '@material-ui/core/CircularProgress';
import Homepage from './Homepage';
import { WidgetType, Widget } from 'pages/Homepage/typings';

function Container() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const widgetTypesStatus = useStatus(getWidgetTypes);
  const widgetTypesData = useData(getWidgetTypes);
  const widgetsStatus = useStatus(getWidgets);
  const widgetsData = useData(getWidgets);
  const status = combineStatuses(widgetTypesStatus, widgetsStatus);
  const widgetTypesInRedux: Array<WidgetType> = useSelector(state =>
    _get(state, ['homepageWidgets', 'widgetTypes']),
  );
  const widgetsInRedux: Array<Widget> = useSelector(state =>
    _get(state, ['homepageWidgets', 'widgets']),
  );

  useEffect(() => {
    if (!widgetTypesInRedux) {
      dispatch(getWidgetTypes());
    }

    if (!widgetsInRedux) {
      dispatch(getWidgets(true));
    }
  }, []);

  if (isLoading(status)) {
    return <CircularProgress color="secondary" className={classes.loading} />;
  }

  if (!isNormal(status)) {
    return <div>Something went wrong.</div>;
  }

  return <Homepage widgetTypes={widgetTypesData.results} widgets={widgetsData.results} />;
}

const useStyles = makeStyles(theme => ({
  root: {},
  loading: {
    display: 'flex',
    margin: 'auto',
  },
}));

export default Container;
